<script setup>
import PwaStatus from "./components/PwaStatus.vue"
</script>

<template>
  <div>
    <router-view />
    <PwaStatus />
  </div>
</template>
